import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const roles = JSON.parse(localStorage.getItem("MCData"));

  const isTokenValid = () => {
    try {
      if (!roles?.token) return false;
      const decoded = JSON.parse(atob(roles.token.split(".")[1]));
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  };

  const isLoggedIn = roles && isTokenValid();

  if (!isLoggedIn) {
    localStorage.clear();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const userRole = roles?.mcdatas?.type || roles?.type;

  // Use the local pathname (e.g., "/waters") instead of the full URL
  const currentPath = location.pathname.toLowerCase();

  if (userRole === "U" && currentPath === "/settingsuser") {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  // Role-based restrictions
  if (
    userRole === "U" &&
    (currentPath.includes("list") ||
      currentPath.includes("metermanagement") ||
      currentPath.includes("stats") ||
      currentPath.includes("devices"))
  ) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // The Allowed List (converted to lowercase for reliable matching)
  const allowedPaths = [
    "dashboard",
    "waters",
    "settings",
    "settingsuser",
    "notification",
    "accountnames",
    "outliers",
    "devices",
    "stats",
    "totalflow",
    "registration",
    "schematics",
    "alert",
    "metermanagement",
    "wateragg",
    "watermeterreadings",
    "predictiveanalysis",
    "anomaly",
    "profile",
    "list",
    "flowhealth",
    "health",
    "meterhistory",
    "meter-leak-details",
    "leak-flow-category",
    "rule-configuration",
    "drought-dashboard",
    "violation-details",
    "drought-report",
    "exemption",
    "waterscombined",
    "capacity-planning",
    "maintenance-upload-review",
  ];

  // Check if current path matches any allowed path (case-insensitive)
  const isAllowedPath = allowedPaths.some((path) =>
    currentPath.includes(path.toLowerCase()),
  );

  if (!isAllowedPath) {
    // Note: Be careful with clearing localStorage here if you have
    // valid sub-routes or query params.
    // If the path isn't in the list, redirect to dashboard or login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
